export default (tableFlag, columnFlag) => columnFlag === undefined ? tableFlag : columnFlag;
